import { asset } from "@/lib/asset";
import { Link } from 'react-router-dom';

export default function News() {
    return (
        <section className="w-full bg-gradient-to-r from-[#6082a0] to-[#e55961]">
            <div className="mx-auto px-0 w-full">
                <div className="flex w-full flex-col md:flex-row items-center justify-center pt-4 pb-5">
                    <div className="px-3 text-center mb-5 md:mb-0 mt-5 w-full md:w-7/12">
                        <span className="text-[18px] xl:text-2xl font-bold font-['Open Sans'] text-white">
                            Последняя новость:
                        </span>
                        <Link to="/blog/reestr-os" className="text-white underline text-[18px] xl:text-2xl font-['Open Sans']">
                            Ключ-АСТРОМ успешно подтвердил нахождение в реестре российского ПО
                        </Link>
                    </div>
                    <div className="text-center mb-5 md:mb-0 mt-5 md:mt-5">
                        <a href="https://reestr.digital.gov.ru/documents/" target="_blank" rel="noopener noreferrer" className="text-center">
                            <img 
                                src={asset("/img/logos/reestr.os.svg")}
                                alt="Реестр российского ПО" 
                                className="logo-1c"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}